/* eslint-disable import/prefer-default-export, no-useless-escape */
export const RulesAndRegex = {
  namesAndSurnames: {
    rules: {
      required: 'Campo obligatorio',
      minLength: { value: 3, message: 'Mínimo 3 caracteres' },
      maxLength: { value: 100, message: 'Máximo 5 caracteres' },
      pattern: {
        value: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ ]+$/,
        message: 'No se permiten caracteres especiales',
      },
    },
    cleanRegex: /[^a-zA-ZáéíóúÁÉÍÓÚñÑ ]/g,
    blockRegex: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ ]$/,
    blockComposing: false,
  },
  cellPhone: {
    rules: {
      required: 'Campo obligatorio',
      minLength: { value: 7, message: 'Mínimo 7 digitos' },
      maxLength: { value: 10, message: 'Máximo 10 digitos' },
      pattern: {
        value: /^[0-9]/,
        message: 'El campo debe ser numérico.',
      },
    },
    cleanRegex: /[^0-9]/g,
    blockRegex: /^[0-9]$/,
    blockComposing: true,
  },
  passport: {
    rules: {
      required: 'Campo obligatorio',
      minLength: { value: 5, message: 'Mínimo 5 digitos' },
      maxLength: { value: 15, message: 'Máximo 15 digitos' },
      pattern: {
        value: /^[a-zA-Z0-9]/,
        message: 'El campo debe ser alfanumérico.',
      },
    },
    cleanRegex: /[^a-zA-Z0-9]/g,
    blockRegex: /^[a-zA-Z0-9]$/,
    allowKey: '',
    blockComposing: true,
  },
  NIT: {
    rules: {
      required: 'Campo obligatorio',
      maxLength: { value: 9, message: 'Máximo 9 digitos' },
      pattern: {
        value: /^[0-9]/,
        message: 'El campo Nit debe ser numérico.',
      },
    },
    cleanRegex: /[^0-9]/g,
    blockRegex: /^[0-9]$/,
    blockComposing: true,
  },
  email: {
    rules: {
      required: 'Campo obligatorio',
      maxLength: { value: 100, message: 'Máximo 100 digitos' },
      pattern: {
        value: /^(?!.*?\.\.)([A-Za-z0-9_\-.+]{3,64})+@([A-Za-z0-9_\-.]{3,})+\.([A-Za-z]{2,})$/,
        message: 'Debe ingresar una dirección de correo válida, mínimo 10 caracteres',
      },
    },
  },
  companyName: {
    rules: {
      required: 'Campo obligatorio',
      minLength: { value: 3, message: 'Mínimo 3 caracteres' },
      maxLength: { value: 100, message: 'Máximo 100 caracteres' },
      pattern: {
        value: /^[a-zA-Z0-9áéíóúÁÉÍÓÚñÑ.\- ]+$/,
        message: 'No se permiten caracteres especiales',
      },
    },
    cleanRegex: /[^a-zA-Z0-9áéíóúÁÉÍÓÚñÑ.\- ]/g,
    blockRegex: /^[a-zA-Z0-9áéíóúÁÉÍÓÚñÑ.\- ]$/,
    blockComposing: false,
  },
  fullAddres: {
    rules: {
      required: 'Campo obligatorio',
      minLength: { value: 3, message: 'Mínimo 3 caracteres' },
      maxLength: { value: 100, message: 'Máximo 100 caracteres' },
      pattern: {
        value: /^[a-zA-Z0-9áéíóúÁÉÍÓÚñÑ.\-#_/]+$/,
        message: 'No se permiten caracteres especiales',
      },
    },
    cleanRegex: /[^a-zA-Z0-9áéíóúÁÉÍÓÚñÑ.\-#_/]/g,
    blockRegex: /^[a-zA-Z0-9áéíóúÁÉÍÓÚñÑ.\-#_/]$/,
    blockComposing: false,
  },
  aditionalInfo: {
    rules: {
      pattern: {
        value: /^\S+( \S+)*$/,
        message: 'No se permiten espacios',
      },
    },
  },
  externalLocation: {
    rules: {
      minLength: {
        value: 3,
        message: 'Mínimo 3 caracteres',
      },
      maxLength: {
        value: 100,
        message: 'Máximo 100 caracteres',
      },
      pattern: {
        value: '^[a-zA-ZáéíóúÁÉÍÓÚñÑ]+(?:(?: - | |-)[a-zA-ZáéíóúÁÉÍÓÚñÑ]+)*$',
        message: 'Debe iniciar con letra y no puede contener espacios al inicio o al final.',
      },
    },
    cleanRegex: '^\\s+|[^a-zA-ZáéíóúÁÉÍÓÚñÑ -]',
    blockRegex: '[a-zA-ZáéíóúÁÉÍÓÚñÑ -]',
    blockComposing: false,
  },
  postalCode: {
    rules: {
      minLength: {
        value: 3,
        message: 'Mínimo 3 caracteres',
      },
      maxLength: {
        value: 10,
        message: 'Máximo 10 caracteres',
      },
      pattern: {
        value: '^[a-zA-Z0-9]+(?:[ -][a-zA-Z0-9]+)*$',
        message: 'Debe iniciar con letra/número, sin espacios o guiones seguidos y sin caracteres especiales.',
      },
    },
    cleanRegex: '[^a-zA-Z0-9 -]',
    blockRegex: '[a-zA-Z0-9 -]',
    blockComposing: false,
  },
};
